module.exports = __webpack_public_path__ + "img/afterViewIcon.cce396c9.svg";